import { render, staticRenderFns } from "./PdfViewContainer.vue?vue&type=template&id=40ebaf64"
import script from "./PdfViewContainer.vue?vue&type=script&lang=js"
export * from "./PdfViewContainer.vue?vue&type=script&lang=js"
import style0 from "./PdfViewContainer.vue?vue&type=style&index=0&id=40ebaf64&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports